<svelte:options customElement="rf-exporter" />

<script lang="ts">
	/**
	 * Imports
	 */
	import { createFullCollection } from '@src/utils/manifest-exporter';

	/**
	 * Props
	 */
	let {} = $props();

	/**
	 * States
	 */

	let result: { collection: unknown; manifests: unknown } | null = $state(null);
	/**
	 * Derived
	 */

	/**
	 * Methods
	 */

	const onKeydown = () => {};

	const handleSubmit = (e: Event) => {
		e.preventDefault();
		const formData = new FormData(e.target as HTMLFormElement);
		const url = formData.get('url') as string;
		const lang = formData.get('lang') as string;
		console.log(url, lang);

		console.log('createFullCollection', createFullCollection(lang));

		result = createFullCollection(lang);
	};
</script>

<svelte:window onkeydown={onKeydown} />

<div
	id="rf-exporter"
	class="rf-exporter"
	part="rf-exporter"
	role="dialog"
	aria-modal="true"
	aria-labelledby="Exporter form"
	onscroll={(e) => e.preventDefault()}
>
	<form class="exporter-form" autocomplete="off" onsubmit={handleSubmit}>
		<label>
			Lang:
			<input type="text" name="lang" placeholder="Enter language" />
		</label>
		<button type="submit">Generate full collection</button>
	</form>

	<pre class="rf-exporter__result">
		{#if result}
			{JSON.stringify(result.collection, null, 2)}
		{:else}
			<p>Type in you language</p>
		{/if}
	</pre>
</div>

<style lang="scss" global>
	.rf-exporter {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		flex-direction: column;

		background-color: rgba(23, 23, 23, 0.8);
		color: white;
		
		width: 100%;
		z-index: 1000;
		border-radius: 5px;

		&__result {
			width: 100%;
			white-space: pre-wrap;
			height: 50vh;
			overflow-y: auto;
			padding: 8px;
			box-sizing: border-box;
		}
	}
</style>
